"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSpeak = void 0;
const isHoldingStick_1 = require("./isHoldingStick");
const hasStickBeenPassed_1 = require("./hasStickBeenPassed");
const isDiscussionHost_1 = require("./isDiscussionHost");
/**
 * Returns whether or not a participant in a discussion is allowed to speak.
 * Participants can speak if the discussion is started and they're the host or current speaker or all chat is enabled.
 */
function canSpeak(discussion, participantId) {
    if (!discussion.startedAt) {
        // discussion hasn't started or has been ended
        return false; // Discussion isn't started, so nobody speaks
    }
    if (discussion.allChat) {
        return true;
    }
    return (isDiscussionHost_1.isDiscussionHost(discussion, participantId) ||
        (!hasStickBeenPassed_1.hasStickBeenPassed(discussion) && isHoldingStick_1.isHoldingStick(discussion, participantId)));
}
exports.canSpeak = canSpeak;
//# sourceMappingURL=canSpeak.js.map